import NotFound from './ErrorPages/Error'
import Dashboard from './Dashboard/Home'
import Home from '../views/Checkout/Home'
import TransactionStatus from './Checkout/TransactionStatus'
import PaymentFailed from './Checkout/PaymentFailed'
import RazorPayCheckout from './Checkout/RazorPayCheckout'
import KotakCheckout from './Checkout/KotakCheckout'
import UpiWaitingPage from './Checkout/UpiWaitingPage'

const sessionRoutes = [
    {
        path: '/VayanaPG/:token',
        component: Home,
    },
    {
        path: '/RazorPay',
        component: RazorPayCheckout,
    },
    {
        path: '/KotakCheckout',
        component: KotakCheckout,
    },
    {
        path: '/PaymentFailed',
        component: PaymentFailed,
    },
    {
        path: '/TransactionStatus',
        component: TransactionStatus,
    },
    {
        path: '/UPI',
        component: UpiWaitingPage,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
    {
        path: '/',
        component: Dashboard,
    },
]

export default sessionRoutes
